<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>

        <div class="main_box">
            <div class="left_box">
                <el-form :model="form" ref="ruleForm_left" label-width="60px" :rules="rules">
                    <el-form-item label="类别:" prop="cates">
                        <el-checkbox-group v-model="form.cates">
                            <el-checkbox v-for="(item, index) in classList"
                                         :label="item"
                                         :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="瘤种:" prop="ill_id">
                        <el-radio-group v-model="form.ill_id" @change="selectIll">
                            <el-radio label="">不选</el-radio>
                            <el-radio v-for="(item, index) in allIllData"
                                         :label="item.id"
                                         :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="form.ill_id && stangesData && stangesData.length > 0"
                                  label="分期:">
                        <el-radio-group v-model="form.ill_cycle_id">
                            <el-radio label="">不选</el-radio>
                            <el-radio v-for="(item, index) in stangesData"
                                      :label="item.id"
                                      :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="封面:" prop="cover">
                        <el-upload
                                class="avatar-uploader"
                                :action="img_upload_url"
                                :show-file-list="false"
                                accept=".jpg, .png, .jpeg"
                                :on-success="uploadSuccess">
                            <img v-if="form.cover" :src="form.cover" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="概要:" prop="brief">
                        <el-input type="textarea"
                                  v-model="form.brief"
                                  placeholder="请输入内容概要"
                                  class="width_all"
                                  :rows="3"></el-input>
                    </el-form-item>
                </el-form>
                <div class="bottom_btn">
                    <el-button @click="openOnLine()">发布</el-button>
                    <el-button type="primary" @click="submit()">存稿</el-button>
                    <el-button plain type="primary" @click="showHtmlLook = true">预览</el-button>
                </div>
            </div>
            <div class="module_box">
                <el-form :model="form" ref="ruleForm_right" label-width="60px" :rules="rules">
                    <el-form-item label="标题:" prop="title">
                        <el-input v-model="form.title" class="width_600" placeholder="标题"></el-input>
                    </el-form-item>
                    <el-form-item label="内容:">
                        <div class="main_box">
                            <div class="text_box">
                                <vue-ueditor-wrap v-model="form.content"
                                                  :config="editorConfig"
                                                  editor-id="editor-demo-01">
                                </vue-ueditor-wrap>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-dialog title="发布图文"
                   width="500px"
                   :modal="false"
                   :visible.sync="dialogOnLine">
            <div class="dia_box">
                <el-form :model="form" label-width="60px">
                    <el-form-item label="标题:">
                        <div>{{form.title}}</div>
                    </el-form-item>
                    <el-form-item label="类别:">
                        <div v-text="showCates(form.cates)"></div>
                    </el-form-item>
                    <el-form-item label="瘤种:">
                        <div v-text="showIll(form.ill_id)"></div>
                    </el-form-item>
                    <el-form-item label="分期:" v-if="form.ill_cycle_id">
                        <div v-text="showIllCycle(form.ill_cycle_id)"></div>
                    </el-form-item>
                    <el-form-item label="封面:">
                        <div class="show_img_box">
                            <img :src="form.cover">
                        </div>
                    </el-form-item>
                    <el-form-item label="通知:">
                        <el-radio-group v-model="target_type">
                            <el-radio :label="1">本科室</el-radio>
                            <el-radio :label="2">全部科室</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogOnLine = false">取 消</el-button>
              <el-button type="primary" @click="submit('online')">确 定</el-button>
            </span>
        </el-dialog>

        <div class="html_look" v-if="showHtmlLook">
            <div class="close_btn">
                <el-button @click="showHtmlLook = false">关闭</el-button>
            </div>
            <div class="phone">
                <div class="main">
                    <div class="title">{{form.title}}</div>
                    <div class="text" v-html="form.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import VueUeditorWrap from 'vue-ueditor-wrap'
    import config from '@/global/config'
    import {clone} from "@/global/utils";

    export default {
        name: "add",
        components: {
            VueUeditorWrap
        },
        data() {
            return {
                viewTitle: '发布图文',
                form: {
                    title: '',
                    cates: [],
                    ill_id: '',
                    ill_cycle_id: '',
                    content: null,
                    cover: '',
                    brief: ''
                },
                img_upload_url: `${config.BASE_URL}/upload?action=uploadimage`,
                showHtmlLook: false,

                stangesData: [],
                rules: {
                    title: [{required: true, message: '请输入标题！', trigger: 'blur'}],
                    cates: [{required: true, message: '请选择类别！', trigger: 'blur'}],
                    ill_id: [{required: true, message: '请选择瘤种！', trigger: 'blur'}],
                    cover: [{required: true, message: '请选择封面！', trigger: 'blur'}],
                    brief: [{required: true, message: '请输入内容概要！', trigger: 'blur'}],
                },
                editorConfig: {
                    UEDITOR_HOME_URL: '/UEditor/',
                    serverUrl: `${config.BASE_URL}/upload`,
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: window.innerHeight - 300,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    charset: "utf-8",
                    toolbars: [
                        [
                            'fullscreen', 'source', '|', 'undo', 'redo', '|',
                            'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', '|',
                            'rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'paragraph', 'fontfamily', 'fontsize', '|',
                            'indent', '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
                            'link', '|', 'simpleupload', 'insertimage', 'emotion', 'insertvideo', '|',
                            'horizontal', 'spechars', '|', 'inserttable', '|', 'preview', 'searchreplace', 'help'
                        ]
                    ],
                    elementPathEnabled: false, //是否启用元素路径，默认是显示
                    wordCount: false, //是否开启字数统计
                },

                dialogOnLine: false,
                target_type: 1,
                fileList: []
            }
        },
        computed: {
            ...mapState('learnData', [
                'classList',
                'allIllData',
                'articleData'
            ])
        },
        mounted() {
            if (this.articleData) {
                this.viewTitle = '修改图文';
                let form = clone(this.articleData);
                // console.log(form, '182');
                this.form.title = form.title;
                this.form.cates = form.cates?form.cates:[];
                this.form.ill_id = form.ill_id;
                this.form.ill_cycle_id = form.ill_cycle_id;
                this.form.content = form.content;
                this.form.cover = form.cover;
                this.form.brief = form.brief;
                this.form.paper_id = form.paper_id; // 修改要带ID

                if (this.form.ill_id) {
                    this.selectIll(this.form.ill_id)
                }
            } else {
                this.viewTitle = '发布图文';
                this.form = {
                    title: '',
                    cates: [],
                    ill_id: '',
                    ill_cycle_id: '',
                    content: null,
                    cover: '',
                    brief: ''
                };
                this.stangesData = []
            }
        },
        methods: {
            showCates(val) {
                let text = val.join(',');
                return text
            },
            showIll(val) {
                let text = '';
                this.allIllData.forEach(e => {
                    if (e.id == val) {
                        text = e.name
                    }
                });
                return text
            },
            showIllCycle(val) {
                let text = '';
                this.stangesData.forEach(e => {
                    if (e.id == val) {
                        text = e.name
                    }
                });
                return text
            },
            selectIll(id) {
                let item = this.allIllData.filter(v => v.id == id);
                if (item.length > 0) {
                    this.stangesData = item[0].cycle_list;
                }
            },
            uploadSuccess(response, file, fileList) {
                this.form.cover = response.url
            },

            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            openOnLine() {
                const that = this;
                that.$refs.ruleForm_left.validate((valid) => {
                    if (valid) {
                        that.$refs.ruleForm_left.validate((valid2) => {
                            if (valid2) {
                                that.dialogOnLine = true
                            }
                        })
                    }
                })
            },

            submit(type) {
                let params = {
                    title: this.form.title,
                    content: this.form.content,
                    ill_id: this.form.ill_id,
                    ill_cycle_id: this.form.ill_cycle_id,
                    cover: this.form.cover,
                    brief: this.form.brief,
                    cates: this.form.cates.join(','),
                };
                if (this.form.paper_id) {
                    params.paper_id = this.form.paper_id
                }
                this.httpPost('/save/paper', params).then(res => {
                    if (type && type === 'online') {
                        this.submitOnline(res.data)
                    } else {
                        this.$message.success('存稿成功！');
                        this.goBack()
                    }
                })
            },
            submitOnline(val) {
                let params = {
                    paper_id: val.paper_id,
                    status: 2,
                    target_type: this.target_type
                };
                this.httpPost('/save/paper/status', params).then(res => {
                    this.$message.success('发布成功！');
                    this.goBack()
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246,247,248);
    $btn_border: rgb(246,247,248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        position: relative;
        z-index: 1;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }
        .main_box {
            background: #fff;
            padding: 10px;
            display: flex;
            height: calc(100% - 50px);
            box-sizing: border-box;
            overflow: hidden;
            overflow-y: auto;
            .left_box {
                flex: 0 0 350px;
                border-right: 1px solid #ddd;
                height: 100%;
                position: relative;
                padding-bottom: 50px;
                box-sizing: border-box;

                .bottom_btn {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    text-align: center;
                }
            }
            .module_box {
                flex: 1;
                height: 100%;
                .main_box {
                    display: flex;
                    .text_box {
                        flex: 1;
                        line-height: initial;
                    }
                    .right_btn_box {
                        padding: 5px 0 5px 10px;
                        flex: 0 0 100px;
                        box-sizing: border-box;
                        .title {
                            line-height: 35px;
                        }
                        .btn {
                            box-sizing: border-box;
                            padding-bottom: 5px;
                        }
                    }
                }

            }
        }

        .html_look {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 999;
            background: #fff;
            .close_btn {
                position: absolute;
                top: 15px;
                right: 15px;
            }
            .phone {
                background: url("../../assets/img/bg_preview_mobile.png");
                width: 388px;
                height: 790px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                .main {
                    background-color: #fff;
                    position: absolute;
                    width: 320px;
                    height: 570px;
                    top: 89px;
                    left: 19px;
                    box-sizing: border-box;
                    overflow: auto;
                    .title {
                        min-height: 80px;
                        color: #333;
                        font-size: 24px;
                        text-align: center;
                        padding-top: 28px;
                    }
                }
            }
        }
    }

    .dia_box {
        .show_img_box {
            width: 200px;
            max-height: 200px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
<style lang="scss">
    .left_box {
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }
    }
</style>